import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FormWidgets, Typeahead } from "../../../Constant";
import { TypeaheadAlert } from "./TypeaheadAlert";
import BasicTypeAhead from "./BasicTypeahead";
import PreFetch from "./Prefetch";
import BloodHound from "./BloodHound";
import RemoteTypeAhead from "./RemoteTypeAhead";
import CustomTemplates from "./CustomTemplates";
import MultipleSectionsWithHeaders from "./MultipleSectionsWithHeaders";
import ScrollableDropdownMenu from "./ScrollableDropdownMenu";
import RtlSupport from "./RTLSupport";

const TypeaheadContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Typeahead} parent={FormWidgets} title={Typeahead} />
      <Container fluid>
        <TypeaheadAlert />
        <div className="typeahead typeahead-wrapper">
          <Row>
            <BasicTypeAhead />
            <PreFetch />
            <BloodHound />
            <RemoteTypeAhead />
            <CustomTemplates />
            <MultipleSectionsWithHeaders />
            <ScrollableDropdownMenu />
            <RtlSupport/>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TypeaheadContainer;
